var PrefMixins = {
    initialize: function () {
        this.overridePrefKeys = {};
        _.each(this.prefKeys, function (prefSpec, basePref) {
            var overridePref = prefSpec[0];
            this.overridePrefKeys[overridePref] = basePref;
            _.each([basePref, overridePref], function (pref, i) {
                var prefKey = this.getPrefKey(pref);
                this.listenTo(this.session, 'prefChange:' + prefKey, function (previousValues) {
                    var prev;
                    if (previousValues) {
                        prev = previousValues[this.id];
                    }
                    if (!_.isEqual(this.getPref(pref), prev)) {
                        this.trigger('prefChange:' + basePref, this, prefKey, prev);
                    }
                });
            }, this);
            this.listenTo(this.session, 'prefChange:' + basePref, function (previousValue) {
                this.trigger('prefChange:' + basePref, this, basePref, previousValue);
            });
        }, this);
    },
    toBasePref: function (pref) {
        return this.overridePrefKeys[pref] || pref;
    },
    prefKeys: {},
    getPrefObject: function (key) {
        return this.session.getPref(this.getPrefKey(key), {});
    },
    getPref: function (key) {
        var pref = this.getPrefObject(key);
        return pref[this.id];
    },
    setPref: function (k, v) {
        var kv;
        // Single arg means full pref object
        if (arguments.length === 2) {
            kv = {};
            kv[k] = v;
        } else {
            kv = k;
        }
        var changes = {};
        _.each(kv, function (value, key) {
            var pref = this.getPrefObject(key);
            var previousValue = pref[this.id];
            if (value) {
                if (!_.isEqual(previousValue, value)) {
                    pref[this.id] = value;
                    changes[key] = [pref, previousValue];
                }
            } else {
                if (previousValue) {
                    delete pref[this.id];
                    changes[key] = [pref, previousValue];
                }
            }
        }, this);
        if (!$.isEmptyObject(changes)) {
            var updates = {};
            _.each(changes, function (prefPair, key) {
                var pref = prefPair[0];
                var previousValue = prefPair[1];
                var basePref = this.toBasePref(key);
                var prefKey = this.getPrefKey(key);
                updates[prefKey] = pref;
                this.trigger('prefChange:' + basePref, this, prefKey, previousValue);
            }, this);
            this.session.setPref(updates);
        }
    },
    setOverridePref: function (enable, basePref) {
        var prefSpec = this.prefKeys[basePref];
        var overridePref = prefSpec[0];
        var defaultValue = prefSpec[1];
        var updates = {};
        if (this.session.getPref(basePref)) {
            // Base pref is globally set
            updates[basePref] = false; // unneeded
            updates[overridePref] = defaultValue ? enable : !enable;
        } else {
            // (Default) not globally set
            updates[basePref] = defaultValue ? !enable : enable;
            updates[overridePref] = false; // unneeded
        }
        this.setPref(updates);
    },
    checkPref: function (basePref) {
        var prefSpec = this.prefKeys[basePref];
        var overridePref = prefSpec[0];
        var defaultValue = prefSpec[1];
        if (this.getPref(basePref)) {
            return !defaultValue;
        } else if (this.session.getPref(basePref)) {
            if (defaultValue) {
                return !!this.getPref(overridePref);
            } else {
                return !this.getPref(overridePref);
            }
        } else {
            return defaultValue;
        }
    }
};


module.exports = PrefMixins;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/mixins/prefmixins.js
// module id = /1Z1
// module chunks = 1